/**
 * Format phone number for Zoom Phone URI scheme
 */
export const formatPhoneForZoom = (phone: string): string => {
  const digits = phone.replace(/\D/g, '')
  if (digits.length === 10) {
    return `+1${digits}`
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`
  }
  return `+${digits}`
}

/**
 * Get Zoom Phone call URI
 */
export const getZoomPhoneUri = (phone: string): string => {
  return `zoomphonecall:${formatPhoneForZoom(phone)}`
}
